import { render, staticRenderFns } from "./AdminTab_Role_Edit.vue?vue&type=template&id=f7811450&scoped=true"
import script from "./AdminTab_Role_Edit.vue?vue&type=script&lang=js"
export * from "./AdminTab_Role_Edit.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Role_Edit.vue?vue&type=style&index=0&id=f7811450&prod&scoped=true&lang=css"
import style1 from "./AdminTab_Role_Edit.vue?vue&type=style&index=1&id=f7811450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7811450",
  null
  
)

export default component.exports